import actionTypes from './constants';

/* */
export const setTournaments = (data) => (dispatch) => dispatch({
  type: actionTypes.SET_TOURNAMENTS,
  payload: data,
});

/* */
export const setCalendar = (data) => (dispatch) => dispatch({
  type: actionTypes.SET_CALENDAR,
  payload: data,
});
